import ImageIcon from "../../../../assets/icons/imageIcon";
import { TbEyeQuestion } from "react-icons/tb";
import styles from "./style.module.scss";

interface ReviewCountersProps {
  counters?: { total: number; forReview?: number };
}
export default function ReviewCounters({ counters }: ReviewCountersProps) {
  const displayForReview = !!counters?.forReview && counters?.forReview > 0;
  return (
    <div className={styles.counters}>
      <div className={styles.counter}>
        <div className={styles.counterIcon}>
          <ImageIcon />
        </div>
        <div>{`${counters?.total} images`}</div>
      </div>
      {displayForReview && (
        <div className={styles.counter}>
          <div className={styles.counterIcon}>
            <TbEyeQuestion />
          </div>
          <div>{`${counters.forReview} For review`}</div>
        </div>
      )}
    </div>
  );
}
